import { TextProps } from "@mantine/core"
import { RiskScore } from "@tfg/db/browser"
import { Missing, TextCell } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

interface Props extends TextProps {
  risk: RiskScore
}

export const RiskScoreDisplay = ({ risk, ...rest }: Props) => {
  const { t } = useTranslation(["suppliers"])

  const propsResolver = useMemo(() => {
    return {
      [RiskScore.LOW]: {
        value: t("risk.low"),
        c: "var(--mantine-color-success)",
      },
      [RiskScore.MEDIUM]: {
        value: t("risk.medium"),
        c: "var(--tag-color-warning)",
      },
      [RiskScore.HIGH]: {
        value: t("risk.high"),
        c: "var(--mantine-color-error)",
      },
    }
  }, [t])

  if (!propsResolver[risk]) {
    return <Missing value="N/A" />
  }

  return <TextCell {...propsResolver[risk]} {...rest} />
}
